


















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class StatusPanel extends Vue {
    @Prop({
        default: '询价单详情',
    })
    public title: string;
    @Prop({
        default: '',
    })
    public status: string;
    @Prop({
        default: '',
    })
    public description: string;

    public created() {}
    public mounted() {
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
    }
    // 方法
    public ratio = 0;
    detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        if (!document.getElementById('title_img')) {
            return;
        }
        if (this.ratio > 100) {
            if (this.ratio <= 110 && this.ratio > 100) {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 13.5%; height: 40%; line-height: 29px;');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: auto;');
                });
            } else if (this.ratio < 120 && this.ratio >= 110) {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 15%; height: 45%; line-height: 30px;');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: auto;');
                });
            } else if (this.ratio < 130 && this.ratio >= 120) {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 15%; height: 40%; line-height: 30px;top:-3%');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: visible;');
                });
            } else if (this.ratio < 140 && this.ratio >= 130) {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 16%; height: 40%; line-height: 30px;');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: auto;');
                });
            } else if (this.ratio <= 150 && this.ratio >= 140) {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 18%; height: 40%; line-height: 29px;');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: auto;');
                });
            }
        } else {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    var BG_IMG_TAG = document.getElementById('title_img');
                    BG_IMG_TAG.setAttribute('style', 'width: 12.5%; height: 41%; line-height: 29px;top:-3%');
                    var BG_Contailer = document.getElementById('contailer');
                    BG_Contailer.setAttribute('style', 'overflow: visible;');
                });
            });
        }
    }
}
